exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".messagedialog{\r\n    -webkit-transition: all .5s;\r\n    transition: all .5s;\r\n    position: absolute;\r\n    top: -50px;\r\n    right: 0;\r\n    padding:0;\r\n    margin: 5px;\r\n    border-radius: 0;\r\n    box-shadow: -2px -1px 5px 1px rgba(0,0,0,.3);\r\n    width: 90%;\r\n    max-width: 450px;\r\n    opacity: .0;\r\n    z-index: -1;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n    border: none;\r\n}\r\n.messagedialog.active{\r\n    top:0;\r\n    opacity: .9;\r\n    z-index: 8;\r\n}\r\n.messagedialog__icon,\r\n.messagedialog__close,\r\n.messagedialog__content {\r\n    padding: 10px 15px;\r\n}\r\n\r\n.alert-success .messagedialog__icon{\r\n    background: rgb(60, 118, 61);\r\n    color: rgb(223, 240, 216);\r\n}\r\n\r\n.alert-danger .messagedialog__icon{\r\n    background: rgb(169, 68, 66);\r\n    color: rgb(242, 222, 222);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/component/message-dialog/message-dialog.component.css
// module id = 657
// module chunks = 0